'use client';
import React from 'react';
import Link from 'next/link';
import { CheckCircle, Circle, ArrowRight } from 'lucide-react';

const completenessItems = [
  { id: 'comp-photo', label: 'Profile photo', done: true },
  { id: 'comp-bio', label: 'Bio / description', done: true },
  { id: 'comp-avail', label: 'Availability schedule', done: true },
  { id: 'comp-tags', label: 'Specialisation tags', done: true },
  { id: 'comp-quals', label: 'Qualifications', done: true },
  { id: 'comp-langs', label: 'Languages', done: true },
  { id: 'comp-docs', label: 'Vetting documents', done: false },
  { id: 'comp-sub', label: 'Subscription active', done: true },
];

export default function WorkerProfileCompleteness() {
  const done = completenessItems?.filter((i) => i?.done)?.length;
  const total = completenessItems?.length;
  const pct = Math.round((done / total) * 100);

  return (
    <div className="card p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-bold text-sm" style={{ color: 'var(--navy)' }}>Profile completeness</h3>
        <span className="text-sm font-extrabold tabular-nums" style={{ color: pct === 100 ? 'var(--success)' : 'var(--primary)' }}>{pct}%</span>
      </div>
      {/* Progress bar */}
      <div className="h-2 rounded-full mb-4 overflow-hidden" style={{ background: 'var(--border)' }}>
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${pct}%`, background: pct === 100 ? 'var(--success)' : 'var(--primary)' }}
        />
      </div>
      <div className="grid grid-cols-2 gap-1.5">
        {completenessItems?.map((item) => (
          <div key={item?.id} className="flex items-center gap-1.5">
            {item?.done
              ? <CheckCircle size={13} style={{ color: 'var(--success)' }} className="flex-shrink-0" />
              : <Circle size={13} style={{ color: 'var(--border)' }} className="flex-shrink-0" />
            }
            <span className="text-xs" style={{ color: item?.done ? 'var(--foreground)' : 'var(--muted-foreground)' }}>{item?.label}</span>
          </div>
        ))}
      </div>
      {pct < 100 && (
        <Link href="/worker-dashboard" className="inline-flex items-center gap-1 mt-3 text-xs font-bold hover:underline" style={{ color: 'var(--primary)' }}>
          Complete your profile <ArrowRight size={12} />
        </Link>
      )}
    </div>
  );
}